import React, { Fragment } from "react";
import GiveLanding from "../components/GiveLanding";
import Navbar from "../components/Navbar";
import FirstFourEpisodes from "./FirstFourEpisodes";
import StoreCTA from "./../components/StoreCTA";

const Give = () => {
  return (
    <Fragment>
      <div className="bg-cream h-full px-8 py-12 md:px-16 md:py-24">
        <Navbar />
        <GiveLanding />
      </div>
      <div className="px-4 py-12 flex justify-between">
        <FirstFourEpisodes />
      </div>
      <StoreCTA />
    </Fragment>
  );
};

export default Give;
